<template>
  <div class="about_container">
    <!-- 描述 -->
    <div class="about_box">
      <div class="about_title font-title">电喵科技</div>
      <!-- 文字描述 -->
      <div class="about_desc">
        <!-- 图 -->
        <div class="about_desc_right">
          <img src="@/assets/images/about/pic_desc.jpg" alt="" />
        </div>
        <div class="about_desc_left">
          <div class="about_desc_co_text">
            电喵科技成立于2017年，位于江苏省中国（南京）软件谷大数据产业基地，专注打造新能源充电场站智能管控全方位综合解决方案的科技公司。
          </div>
          <div class="about_desc_co_text">
            团队历时三年打造了国内首家聚焦新能源充电行业的AIoT平台，融合大模型生成式AI及智能语音交互，链接自主研发的智能车牌识别相机系统、智能车位锁系统、智能道闸系统、智能安防系统，
            赋能充电站安全运营，提高充电站智慧运维，提供绿色、数字化创新的新能源充电场站一站式管控服务。
          </div>
          <div class="about_desc_co_text">
            目前电喵已与国内众多知名充电桩运营企业、主机厂、传统能源企业、第三方充电平台以及城市级运营商建立深度合作关系，产品及施工运维网络覆盖全国33个省市及自治区。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.about_container {
  width: 100vw;
  padding-bottom: 6vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  @media screen and (max-width: 960px) {
    width: 960px;
  }
}
.about_box {
  min-width: 960px;
  padding-bottom: 6vh;
  margin: 0 auto;
  color: #000;

  .about_title {
    padding-top: 10vh;
    width: 50%;
    margin-left: 35%;
    text-align: center;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    user-select: none; /* Standard syntax */
  }

  .about_desc {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 5vw;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .about_desc_left {
      width: 50%;
      margin-left: 5%;
      display: flex;
      flex-direction: column;
      align-content: space-between;

      .about_desc_co_text {
        font-size: 18px;
        text-indent: 36px;
        line-height: 36px;
        @media screen and (max-width: 1440px) {
          font-size: 16px;
          text-indent: 32px;
          line-height: 32px;
        }
        @media screen and (max-width: 1160px) {
          font-size: 14px;
          text-indent: 28px;
          line-height: 28px;
        }
      }
    }

    .about_desc_right {
      width: 30%;
      display: flex;
      justify-content: center;

      img {
        aspect-ratio: 2;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}

.about_cover_box {
  margin: 65px 5vw 0 5vw;
  padding: 20px 0;
  box-sizing: border-box;
  border-top: 2px solid #7c7c7c;
  border-bottom: 2px solid #7c7c7c;

  .about_cover {
    margin: 0 20px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-evenly;

    .about_cover_item {
      text-align: center;

      .about_cover_num {
        font-size: 18px;
        font-weight: 600;

        @media screen and (max-width: 1440px) {
          font-size: 16px;
          text-indent: 32px;
          line-height: 32px;
        }
        @media screen and (max-width: 1160px) {
          font-size: 14px;
          text-indent: 28px;
          line-height: 28px;
        }

        span {
          margin-left: 5px;
          font-weight: 400;
        }
      }

      .about_cover_text {
        font-size: 18px;
        margin-bottom: 20px;

        @media screen and (max-width: 1440px) {
          font-size: 16px;
          text-indent: 32px;
        }
        @media screen and (max-width: 1160px) {
          font-size: 14px;
          text-indent: 28px;
        }
      }
    }
  }
}
</style>
